<h2 mat-dialog-title>{{ heading }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="dialog-form">
    <mat-form-field>
      <mat-label>RPL</mat-label>
      <input matInput type="text" [formControl]="rplControl" [matAutocomplete]="rplAuto"
             (input)="searchRpl($any($event.target).value)" required>
      <mat-autocomplete #rplAuto="matAutocomplete" [displayWith]="displayCodingSchema" [panelWidth]="'40vw'">
        <mat-option *ngFor="let option of rplOptions" [value]="option" class="custom-mat-option">
          {{ displayCodingSchema(option) }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Primary ICD</mat-label>
      <input matInput type="text" [formControl]="diagnosisControl" [matAutocomplete]="diagnosisAuto"
             (input)="searchDiagnosis($any($event.target).value)" required>
      <mat-autocomplete #diagnosisAuto="matAutocomplete" [displayWith]="displayDiagnosis" [panelWidth]="'40vw'">
        <mat-option *ngFor="let option of diagnosisOptions" [value]="option" class="custom-mat-option">
          {{ displayDiagnosis(option) }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field>
      <mat-label>CCSA</mat-label>
      <input matInput type="text" [formControl]="ccsaControl" [matAutocomplete]="ccsaAuto"
             (input)="searchCcsa($any($event.target).value)">
      <mat-autocomplete #ccsaAuto="matAutocomplete" [displayWith]="displayCodingSchema" [panelWidth]="'40vw'">
        <mat-option *ngFor="let option of ccsaOptions" [value]="option" class="custom-mat-option">
          {{ displayCodingSchema(option) }}
        </mat-option>
      </mat-autocomplete>
      <button *ngIf="ccsaControl.value" mat-button mat-icon-button matSuffix type="button"
              aria-label="Clear CCSA" (click)="clearCcsa()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Minimum age</mat-label>
      <input matInput type="number" min="0" step="1" formControlName="minimumAge">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Maximum age</mat-label>
      <input matInput type="number" min="0" step="1" formControlName="maximumAge">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Age unit</mat-label>
      <mat-select formControlName="ageUnit">
        <mat-option [value]="null">Unrestricted</mat-option>
        <mat-option value="YEARS">Completed years</mat-option>
        <mat-option value="DAYS">Completed days</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="wide">
      <mat-label>Notes</mat-label>
      <textarea matInput formControlName="notes" rows="3" maxlength="4000"></textarea>
    </mat-form-field>

    <div class="wide checkbox-row">
      <mat-checkbox formControlName="active">Active</mat-checkbox>
      <mat-checkbox formControlName="requiresClinicalReview">Requires clinical review</mat-checkbox>
    </div>
  </form>

  <p *ngIf="error" role="alert" class="error">{{ error }}</p>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="saving">Save</button>
  <button mat-raised-button color="warn" type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
</mat-dialog-actions>
